/** Mappa campi anagrafica medico → sezione sanitaria fascicolo */
export function applyDoctorToSanitaria(doctor) {
  if (!doctor) return {};
  return {
    doctor_id: doctor.id,
    medico_curante: doctor.name || "",
    medico_curante_telefono: doctor.phone || "",
    medico_curante_email_personale: doctor.email || "",
    medico_curante_email_blisteraggio: doctor.blistering_email || "",
    medico_curante_indirizzo_studio: doctor.address || "",
    asl_riferimento: doctor.asl_reference || "",
  };
}

export function doctorInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.slice(0, 2) || "?").toUpperCase();
}

export function doctorMatchesSearch(doctor, query) {
  const q = String(query || "")
    .trim()
    .toLowerCase();
  if (!q) return true;
  const name = String(doctor?.name || "").toLowerCase();
  const parts = name.split(/\s+/);
  return name.includes(q) || parts.some((p) => p.includes(q));
}

export const EMPTY_DOCTOR_FORM = {
  name: "",
  specialization: "",
  phone: "",
  email: "",
  blistering_email: "",
  address: "",
  asl_reference: "",
  notes: "",
  is_default: false,
};

export function doctorToForm(doctor) {
  if (!doctor) return { ...EMPTY_DOCTOR_FORM };
  return {
    name: doctor.name || "",
    specialization: doctor.specialization || "",
    phone: doctor.phone || "",
    email: doctor.email || "",
    blistering_email: doctor.blistering_email || "",
    address: doctor.address || "",
    asl_reference: doctor.asl_reference || "",
    notes: doctor.notes || "",
    is_default: !!doctor.is_default,
  };
}
